import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr auto;
  grid-template-areas:
    'text text text date'
    'image amount result date';
  grid-column-gap: 0.5rem;
`;
